import React from 'react';
import { Modal, Input, Spin } from "antd";
import { tvLoginApi } from './utils/ApiUtils';
import { COLORS } from './utils/Constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

let inputHeight = 41;

export default class TVLoginModal extends React.Component {
  
  state = { visible: true, displayText: 'Enter the code shown on your TV', userToken: '', loader: false };
  setModalVisible(visible) {
    this.setState({ visible: visible });
    console.log('setModalVisible='+visible);
    this.props.setVisibility();
  }
  onChangeToken = e => {
    console.log('onChange Token='+e.target.value);
    this.setState({ userToken: e.target.value });
  }
  callTVLogin = () => {
      let { sessionValue, email } = this.props;
    let userToken = this.state.userToken;
    console.log('user Token='+userToken);
    if(userToken.length<6) {
      this.setState({ displayText: 'Please enter correct token.' });
      return;
    }
    if(this.state.loader) {
      return;
    }
    this.setState({ loader: true });
    tvLoginApi(sessionValue, email, userToken)
      .then(response => {
        console.log('got verifySignUpApi='+JSON.stringify(response));
        if(response.ok) {
          this.props.setVisibility();
        } else {
          this.setState({ loader: false, displayText: response.info&&response.info.result ? response.info.result : 'Please enter correct token.' });  
        }
      })
      .catch((error) => {
        console.log('Error getting login'+JSON.stringify(error));
        this.setState({ loader: false, displayText: 'Please enter correct token.' });
      });
  }
  render() {
    let isMobile = window.innerWidth<768;
    return (
      <Modal
        width={320}
        closable={false}
        centered={isMobile ? true : false}
        bodyStyle={{ top: isMobile ? '10%' : '0%', height: 420, padding: 0, backgroundColor: COLORS.white }}
        visible={this.state.visible}
        onOk={() => this.setModalVisible(false)}
        onCancel={() => this.setModalVisible(false)}
        footer={null}
      >
        <div style={{ display: 'flex', width: '100%', height: '100%', flexDirection: 'column', padding: 4, backgroundColor: COLORS.yellow }}>
          <div style={{ display: 'flex', justifyContent:'center', height: '18%', backgroundColor: COLORS.blue2a3a4a }}>
            <div style={{ display: 'flex', justifyContent:'center', height: '100%', width: '100%' }}>
              <div style={{ flex:1, textAlign: 'center', alignSelf: 'center', margin: 0, fontSize: 20, color: COLORS.yellow, fontFamily: 'OpenSans-Bold' }} >
                TV Login
              </div>
            </div>
          </div>
          <div style={{ width:'100%', height: 0, backgroundColor: COLORS.yellow }} />
          <div style={{ height: '65%', paddingLeft: 24, paddingRight: 24, backgroundColor: COLORS.lightBlue }}>
            <div style={{ width: '100%', height: '100%' }}>
                <div style={{ height: '30%', display: 'flex', justifyContent: 'center' }}>
                    <h4 style={{ color: COLORS.yellow, textAlign:'center', alignSelf: 'flex-end', fontFamily: 'OpenSans-SemiBold' }}>
                        {this.state.displayText}
                    </h4>
                </div>
                <div style={{ height: '40%' }}>
                    <Input size='large' maxLength={6} className="loginInput" placeholder="ABC123" onChange={this.onChangeToken} 
                    style={{ marginTop:'15%', fontFamily: 'OpenSans-Bold', height: inputHeight, textAlign: 'center', borderRadius: 20 }}
                    onPressEnter={() => { this.callTVLogin() }} />
                </div>
            </div>
          </div>
          <div style={{ width:'100%', height: 0, backgroundColor: COLORS.yellow }} />
          <div style={{ display: 'flex', justifyContent:'center', alignContent:'center', height: '17%', backgroundColor: COLORS.blue2a3a4a }}>
            <div style={{ flex:1, alignSelf:'center', textAlign:'center', marginLeft: 20 }}>
                <FontAwesomeIcon className='loginSubmit' icon={faTimes} onClick={() => this.setModalVisible(false)} 
                style={{ cursor: 'pointer', fontSize: 34 }} />
            </div>
            <div style={{ flex:1, alignSelf:'center', textAlign: 'center', marginRight: 20 }}>
              <FontAwesomeIcon className='loginSubmit' icon={faCheck} onClick={() => this.callTVLogin()} 
               style={{ cursor: 'pointer', fontSize: 34 }} />
              { this.state.loader &&
                <div style={{ position: 'absolute', display: 'flex', justifyContent: 'center', alignItems: 'center', right: 20, bottom: 28 }}>
                <Spin size='small' style={{  }} />
                </div>
              }
            </div>
          </div>
        </div>
      </Modal>
  );
  }
}